'use client';

import { FC, useEffect, useRef } from 'react';
import { Content, isFilled } from '@prismicio/client';
import { SliceComponentProps, PrismicRichText } from '@prismicio/react';
import { PrismicNextImage } from '@prismicio/next';

const PhaseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    className="shrink-0"
  >
    <path
      d="M23.999 21.3066C27.5042 21.3066 30.3457 18.501 30.3457 15.04C30.3457 11.579 27.5042 8.77332 23.999 8.77332C20.4938 8.77332 17.6523 11.579 17.6523 15.04C17.6523 18.501 20.4938 21.3066 23.999 21.3066Z"
      fill="#03BF9E"
    />
    <path
      d="M14.3747 15.6666H15.0147V15.0933C15.0185 13.4261 15.4889 11.7932 16.3725 10.3794C17.2561 8.96565 18.5178 7.82734 20.0147 7.09328C19.5715 6.07269 18.8602 5.19119 17.9563 4.54239C17.0524 3.89359 15.9897 3.50173 14.8809 3.40842C13.7722 3.31511 12.6589 3.52384 11.6593 4.01244C10.6597 4.50103 9.81103 5.25125 9.20354 6.18342C8.59605 7.11558 8.25237 8.19488 8.20901 9.30668C8.16565 10.4185 8.42423 11.5213 8.95729 12.4979C9.49034 13.4745 10.278 14.2886 11.2365 14.8535C12.195 15.4185 13.2887 15.7133 14.4013 15.7066L14.3747 15.6666ZM33.0147 15.0399V15.6133H33.6547C34.7525 15.6023 35.827 15.2955 36.7652 14.7253C37.7033 14.155 38.4704 13.3424 38.9857 12.373C39.5009 11.4036 39.7453 10.3132 39.6931 9.21655C39.6409 8.11993 39.2941 7.05766 38.689 6.14156C38.084 5.22546 37.2432 4.4894 36.2551 4.01087C35.267 3.53234 34.1682 3.32903 33.0743 3.42235C31.9804 3.51566 30.9319 3.90215 30.0392 4.54112C29.1464 5.1801 28.4424 6.04793 28.0013 7.05328C29.4987 7.78447 30.7617 8.9199 31.6476 10.3312C32.5336 11.7426 33.0071 13.3736 33.0147 15.0399ZM29.7213 21.9333C32.3721 22.4589 34.9353 23.3566 37.3347 24.5999C37.6728 24.7854 37.9789 25.024 38.2413 25.3066H45.3347V20.7466C45.336 20.5717 45.2894 20.3998 45.2001 20.2494C45.1109 20.099 44.9822 19.9759 44.828 19.8933C41.3722 18.0857 37.528 17.1475 33.628 17.1599H32.748C32.2859 19.0382 31.2232 20.7143 29.7213 21.9333ZM8.708 27.8933C8.70556 27.2218 8.88691 26.5624 9.2324 25.9866C9.57789 25.4108 10.0743 24.9405 10.668 24.6266C13.0674 23.3833 15.6305 22.4855 18.2813 21.9599C16.7868 20.7513 15.7247 19.0904 15.2547 17.2266H14.3747C10.4747 17.2142 6.63046 18.1524 3.17466 19.9599C3.02049 20.0425 2.8918 20.1657 2.80251 20.3161C2.71321 20.4665 2.6667 20.6384 2.668 20.8133V29.3333H8.708V27.8933ZM28.6147 35.5866H36.5613V37.4533H28.6147V35.5866Z"
      fill="#03BF9E"
    />
    <path
      d="M43.7484 28.3466H34.5884V27.0133C34.5884 26.6597 34.4479 26.3205 34.1978 26.0705C33.9478 25.8204 33.6086 25.6799 33.255 25.6799C32.9014 25.6799 32.5623 25.8204 32.3122 26.0705C32.0622 26.3205 31.9217 26.6597 31.9217 27.0133V28.3466H29.335V24.5733C27.581 24.2034 25.7942 24.0113 24.0017 23.9999C19.7936 23.984 15.6458 25.0004 11.9217 26.9599C11.7558 27.046 11.617 27.1762 11.5205 27.3362C11.4241 27.4962 11.3737 27.6798 11.375 27.8666V35.3466H20.855V43.4666C20.855 43.8202 20.9955 44.1594 21.2455 44.4094C21.4956 44.6595 21.8347 44.7999 22.1884 44.7999H43.7484C44.102 44.7999 44.4411 44.6595 44.6912 44.4094C44.9412 44.1594 45.0817 43.8202 45.0817 43.4666V29.6799C45.0817 29.3263 44.9412 28.9872 44.6912 28.7371C44.4411 28.4871 44.102 28.3466 43.7484 28.3466ZM42.415 42.1599H23.5217V31.0133H31.9217V32.2266C31.9217 32.5802 32.0622 32.9194 32.3122 33.1694C32.5623 33.4195 32.9014 33.5599 33.255 33.5599C33.6086 33.5599 33.9478 33.4195 34.1978 33.1694C34.4479 32.9194 34.5884 32.5802 34.5884 32.2266V31.0133H42.415V42.1599Z"
      fill="#03BF9E"
    />
  </svg>
);

/**
 * Props for `ModernizationChecklistSection`.
 */
export type ModernizationChecklistSectionProps =
  SliceComponentProps<Content.ModernizationChecklistSectionSlice>;

/**
 * Component for "Modernization Checklist Section" Slices.
 */
const ModernizationChecklistSection: FC<ModernizationChecklistSectionProps> = ({
  slice,
}) => {
  const { title, subtitle, intro_text, budget_chart_image, phases } =
    slice.primary;

  const headingRef = useRef<HTMLDivElement>(null);
  const chartRef = useRef<HTMLDivElement>(null);
  const cardRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.15,
      rootMargin: '0px 0px -10% 0px',
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove('opacity-0', 'translate-y-8');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Heading block (title + subtitle + intro) — fade up
    if (headingRef.current) {
      headingRef.current.classList.add(
        'opacity-0',
        'translate-y-8',
        'transition-all',
        'duration-700',
        'ease-out',
      );
      observer.observe(headingRef.current);
    }

    // Chart image — fade up with slight delay
    if (chartRef.current) {
      chartRef.current.classList.add(
        'opacity-0',
        'translate-y-8',
        'transition-all',
        'duration-700',
        'ease-out',
      );
      chartRef.current.style.transitionDelay = '200ms';
      observer.observe(chartRef.current);
    }

    // Phase cards — staggered fade up
    cardRefs.current.forEach((card, index) => {
      if (card) {
        card.classList.add(
          'opacity-0',
          'translate-y-8',
          'transition-all',
          'duration-700',
          'ease-out',
        );
        card.style.transitionDelay = `${index * 150}ms`;
        observer.observe(card);
      }
    });

    return () => observer.disconnect();
  }, [phases]);

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="w-full py-16 md:py-[80px]"
    >
      <div className="mx-auto max-w-[1380px] px-5 md:px-[100px]">
        {/* ── Top: headline + chart, separated by bottom border ── */}
        <div className="flex flex-col gap-8 border-b-2 border-[#eee] md:flex-row md:items-end md:gap-[60px]">
          {/* Left: title + subtitle + intro */}
          <div
            ref={headingRef}
            className="flex flex-1 flex-col justify-center gap-6 pb-10 text-[#041118]"
          >
            <div>
              {isFilled.richText(title) && (
                <div className="font-inter text-[32px] font-medium leading-[1.2] md:text-[42px] [&_h1]:text-[32px] [&_h1]:font-medium md:[&_h1]:text-[42px] [&_em]:not-italic [&_em]:text-[#03BF9E] [&_strong]:font-semibold [&_strong]:text-[#03BF9E]">
                  <PrismicRichText field={title} />
                </div>
              )}

              {isFilled.richText(subtitle) && (
                <div className="font-inter text-[32px] font-medium leading-[1.2] text-[#03BF9E] md:text-[42px] [&_h2]:text-[32px] [&_h2]:font-medium md:[&_h2]:text-[42px]">
                  <PrismicRichText field={subtitle} />
                </div>
              )}
            </div>

            {isFilled.richText(intro_text) && (
              <div className="font-inter text-[16px] font-normal leading-[1.5] md:text-[18px] [&>p+p]:mt-4">
                <PrismicRichText field={intro_text} />
              </div>
            )}
          </div>

          {/* Right: budget chart image */}
          {isFilled.image(budget_chart_image) && (
            <div ref={chartRef} className="w-full shrink-0 md:w-[403px]">
              <PrismicNextImage
                field={budget_chart_image}
                className="h-auto w-full object-contain"
              />
            </div>
          )}
        </div>

        {/* ── Bottom: 2x2 phase cards grid ── */}
        {phases && phases.length > 0 && (
          <div className="mt-10 grid grid-cols-1 gap-10 sm:grid-cols-2">
            {phases.map((phase, idx) => (
              <div
                key={idx}
                ref={(el) => {
                  cardRefs.current[idx] = el;
                }}
                className="flex flex-col gap-6 rounded-[16px] border-2 border-[#eee] p-6"
              >
                {/* Card image */}
                {isFilled.image(phase.image) && (
                  <div className="h-[273px] overflow-hidden rounded-[16px]">
                    <PrismicNextImage
                      field={phase.image}
                      className="h-full w-full object-cover"
                    />
                  </div>
                )}

                {/* Icon + Title */}
                <div className="flex items-center gap-4">
                  <PhaseIcon />
                  {isFilled.richText(phase.phase_title) && (
                    <div className="font-inter text-[22px] font-semibold uppercase leading-[1.4] text-[#041118] md:text-[26px]">
                      <PrismicRichText field={phase.phase_title} />
                    </div>
                  )}
                </div>

                {/* Description */}
                {isFilled.richText(phase.phase_description) && (
                  <div className="font-inter text-[16px] font-normal leading-[1.4] text-[#041118] md:text-[18px]">
                    <PrismicRichText field={phase.phase_description} />
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ModernizationChecklistSection;
